import { useTranslation } from "react-i18next";
import { Check, Languages } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { SUPPORTED_LANGUAGES } from "@/i18n";

export function LanguageSwitcher({ variant = "ghost", size = "sm", testId = "lang-switcher" }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.split("-")[0] || "en";

  const change = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size={size}
          className="gap-2"
          data-testid={testId}
        >
          <Languages className="h-4 w-4" />
          <span className="hidden sm:inline text-xs font-semibold uppercase tracking-wide">
            {current}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <DropdownMenuLabel className="text-xs uppercase tracking-wide text-slate-500">
          {t("languages.select")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_LANGUAGES.map((lng) => (
          <DropdownMenuItem
            key={lng}
            onClick={() => change(lng)}
            data-testid={`lang-option-${lng}`}
            className="flex items-center justify-between gap-3"
          >
            <span>{t(`languages.${lng}`)}</span>
            {current === lng ? <Check className="h-4 w-4 text-slate-700" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
